import { routePaths } from "./routes";
import { organization } from "../content/config";
import type { Locale } from "../types/content";

export function pageTitle(title: string) {
  const suffix = organization.registrationStatus === "registered" ? organization.legalNameEn : organization.brandName;
  return `${title} | ${suffix}`;
}

export function canonicalUrl(locale: Locale, path: string) {
  const clean = path.replace(/^\/+/, "");
  return `https://transition-bridge.pages.dev/${locale}${clean ? `/${clean}` : ""}`;
}

export function hrefLangs(path: string) {
  return ["en", "ro", "he"].map((locale) => ({
    lang: locale,
    href: canonicalUrl(locale as Locale, path)
  }));
}

export function organizationJsonLd() {
  const data: Record<string, unknown> = {
    "@context": "https://schema.org",
    "@type": organization.registrationStatus === "registered" ? "NGO" : "Organization",
    name: organization.brandName,
    alternateName: organization.shortName
  };
  if (organization.email) data.email = organization.email;
  if (organization.phone) data.telephone = organization.phone;
  if (organization.address) data.address = organization.address;
  return data;
}

export const indexedRoutes = routePaths;
